'use client';

import {useColorModeValue, Image} from '@linx-security/ui';
import SpinnerOnBlack from '@public/images/spinners/logo_on-black.gif';
import SpinnerOnWhite from '@public/images/spinners/logo_on-white.gif';

import LoginLayout from '../(auth)/layout';

type Props = {
  size?: number;
};
export const Spinner = (props: Props) => {
  const colorMode = useColorModeValue(SpinnerOnWhite, SpinnerOnBlack);
  const {size = 80} = props;
  return (
    <div role="status">
      <Image
        src={colorMode.src}
        alt="Loading..."
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      />
    </div>
  );
};

export const FullPageSpinner = (props: Props) => {
  return (
    <LoginLayout>
      <Spinner {...props} />
    </LoginLayout>
  );
};
